import GoBack from 'components/general/go_back';
import { useMediaQuery } from 'react-responsive';

const TitleHistoryBack = (props) => {
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)'
  });
  const { title, subTitle, hideBackButton } = props;
  const singleLine = subTitle == null || subTitle === '';
  return (
    <div>
      <div className="d-flex align-items-center gap-3 pt-2 pb-1">
        {!hideBackButton && <GoBack />}
        <div className="">
          {singleLine ? (
            <div
              className={`fs-7 text-uppercase lh-1 ${
                isDesktop ? 'text-white' : 'text-secondary'
              } `}>
              {title}
            </div>
          ) : (
            <>
              <div
                className={`fs-7 text-uppercase mb-1 lh-1 ${
                  isDesktop ? 'text-white' : 'text-secondary'
                } `}>
                {title}
              </div>
              <h6 className={`mb-0 fw-bold ${isDesktop ? 'text-white' : 'text-secondary'} `}>
                {subTitle}
              </h6>
            </>
          )}
        </div>
      </div>
      <hr className="my-1" />
    </div>
  );
};

export default TitleHistoryBack;
